export default "__VITE_ASSET__yV1r9v5w__"